import { Routes } from '@angular/router';
import { BootstrapCompetitionsComponent } from './bootstrap-competitions/bootstrap-competitions.component';
const ɵ0 = () => import("./event-info/competition-event-info.module.ngfactory").then(m => m.CompetitionEventInfoModuleNgFactory), ɵ1 = () => import("./angular-js/angular-js.module.ngfactory").then(m => m.AngularJsModuleNgFactory), ɵ2 = () => import("./competition-quotes/competition-quotes.module.ngfactory").then(m => m.CompetitionQuotesModuleNgFactory), ɵ3 = () => import("./competitions-news/competitions-news.module.ngfactory").then(m => m.CompetitionsNewsModuleNgFactory), ɵ4 = () => import("./competitions-photos/competitions-photos.module.ngfactory").then(m => m.CompetitionsPhotosModuleNgFactory), ɵ5 = () => import("./competition-entries/competition-entries.module.ngfactory").then(m => m.CompetitionEntriesModuleNgFactory), ɵ6 = () => import("./competition-ranking/competition-ranking.module.ngfactory").then(m => m.CompetitionRankingModuleNgFactory);
const routes = [{
        path: '', component: BootstrapCompetitionsComponent,
        children: [
            { path: '', loadChildren: ɵ0 },
            { path: 'results', loadChildren: ɵ1 },
            { path: 'quotes', loadChildren: ɵ2 },
            { path: 'news', loadChildren: ɵ3 },
            { path: 'photos', loadChildren: ɵ4 },
            { path: 'entries', loadChildren: ɵ5 },
            { path: 'ranking', loadChildren: ɵ6 },
            {
                path: 'ranking/entries',
                redirectTo: 'entries'
            }
        ]
    }];
export class CompetitionsRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
